import { render } from "./property-fees-card.vue?vue&type=template&id=67b94821"
import script from "./property-fees-card.vue?vue&type=script&lang=js"
export * from "./property-fees-card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__